import { render } from "./benchmarkDownload.vue?vue&type=template&id=3f656612&scoped=true"
import script from "./benchmarkDownload.vue?vue&type=script&lang=js"
export * from "./benchmarkDownload.vue?vue&type=script&lang=js"

import "./benchmarkDownload.vue?vue&type=style&index=0&id=3f656612&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f656612"]])

export default __exports__